import { useCallback } from 'react';
import { FaqDto, FrequentQuestion } from 'types/types';

const isValidResponseAndPageLocation = (response: any, pageLocation: any): boolean => {
  return response?.length && pageLocation?.pathname;
};

const normalizeString = (str: string) => str.toLowerCase().trim();

const getFilteredModuleData = (moduleName: string, response: any, pageLocation: any): any[] => {
  return response.filter(
    ({ module, pageURL }: any) =>
      module &&
      module === moduleName &&
      normalizeString(pageLocation.pathname) === normalizeString(pageURL.toString())
  );
};

const getFaqData = (filteredModuleData: any[]): FaqDto | undefined => {
  if (!filteredModuleData?.length) return;

  return {
    title: filteredModuleData[0].title,
    module: filteredModuleData[0].module,
    questions: filteredModuleData
      .map((content: any) => ({
        question: content.questionText,
        answer: content.answerText,
      }))
      .filter(
        (frequentAskedQuestion: FrequentQuestion) =>
          frequentAskedQuestion.question && frequentAskedQuestion.answer
      ),
  } as FaqDto;
};

export const useHelpSectionFAQData = () => {
  return useCallback((moduleName: string, response: any, pageLocation: any) => {
    if (!isValidResponseAndPageLocation(response, pageLocation)) return;

    const filteredModuleData = getFilteredModuleData(moduleName, response, pageLocation);

    return getFaqData(filteredModuleData);
  }, []);
};
